(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Code", [], factory);
	else if(typeof exports === 'object')
		exports["Code"] = factory();
	else
		root["Code"] = factory();
})(window, function() {
return 